/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type QuestionType = (typeof QuestionType)[keyof typeof QuestionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionType = {
  text: 'text',
  single_choice: 'single_choice',
  multiple_choice: 'multiple_choice',
} as const;
